export default __webpack_public_path__ + "static/media/medical-device.f1c6a898.svg";